import React, { Component } from 'react';
import { DeadlineBanner } from '../components/DeadlineBanner';
import { NewHero } from '../components/NewHero';
import { NewProblemSection } from '../components/NewProblemSection';
import { AlexandriaSection } from '../components/AlexandriaSection';
import { PSIGatheringSection } from '../components/PSIGatheringSection';
import { PSIProDifferenceSection } from '../components/PSIProDifferenceSection';
import { PSIProBenefitsSection } from '../components/PSIProBenefitsSection';
import { PeptideMasteryDetailSection } from '../components/PeptideMasteryDetailSection';
import { DirectAccessSection } from '../components/DirectAccessSection';
import { PeptideMasteryComponent } from '../components/PeptideMasteryComponent';
import { FreeOfferReveal } from '../components/FreeOfferReveal';
import { ApplicationAndPricingSection } from '../components/ApplicationAndPricingSection';
import { QualificationSection } from '../components/QualificationSection';
import { NoGuarantee } from '../components/NoGuarantee';
import { ProTestimonials } from '../components/ProTestimonials';
import { FAQSection } from '../components/FAQSection';
import { StakesSection } from '../components/StakesSection';
import { DeadlineScarcity } from '../components/DeadlineScarcity';
import { FinalCTA } from '../components/FinalCTA';
import { MysteryLayer } from '../components/MysteryLayer';
export function NewLandingPage() {
  return <div className="bg-black text-stone-200 min-h-screen relative overflow-x-hidden" data-id="element-4709">
      {/* Background layer */}
      <MysteryLayer data-id="element-4710" />

      {/* Sticky urgency banner */}
      <DeadlineBanner data-id="element-4711" />

      {/* HOOK */}
      <NewHero data-id="element-4712" />

      {/* PROBLEM / AGITATION */}
      <NewProblemSection data-id="element-4713" />

      {/* SOLUTION INTRO */}
      <AlexandriaSection data-id="element-4714" />
      <PSIGatheringSection data-id="element-4715" />

      {/* WHAT MAKES PRO DIFFERENT */}
      <PSIProDifferenceSection data-id="element-4716" />
      <PSIProBenefitsSection data-id="element-4717" />

      {/* WHAT YOU GET */}
      <PeptideMasteryDetailSection data-id="element-4718" />
      <DirectAccessSection data-id="element-4719" />
      <PeptideMasteryComponent data-id="element-4720" />

      {/* THE OFFER */}
      <FreeOfferReveal data-id="element-4721" />
      <ApplicationAndPricingSection data-id="element-4722" />

      {/* CLOSE */}
      <QualificationSection data-id="element-4723" />
      <NoGuarantee data-id="element-4724" />
      <ProTestimonials data-id="element-4725" />
      <FAQSection data-id="element-4726" />
      <StakesSection data-id="element-4727" />
      <DeadlineScarcity data-id="element-4728" />
      <FinalCTA data-id="element-4729" />
    </div>;
}